<!--
  Dialog de impressao do pedido.
  Estrutura espelha fatura-view.component.html (linhas 709-778) — duplicacao
  intencional (decisao do Tech Lead, ver DESIGN_FE v2 Decisao 2).
-->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '42rem', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-print" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'pedidos.imprimir_pedido.titulo' | translate }}</h2>
        <p>{{ 'pedidos.imprimir_pedido.subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <form [formGroup]="tipoDeImpressaoForm">
      <div class="field">
        <label class="mb-3">{{ 'pedidos.imprimir_pedido.label_formato' | translate }}</label>
        <div class="flex flex-column gap-3">
          <div class="flex items-center">
            <p-radioButton name="impressao" value="A4" formControlName="impressao"
              inputId="pedidoImpressaoA4"></p-radioButton>
            <label for="pedidoImpressaoA4" class="ml-2 font-normal">
              {{ 'pedidos.imprimir_pedido.formatos.a4' | translate }}
            </label>
          </div>
          <div class="flex items-center">
            <p-radioButton name="impressao" value="BOBINA_58" formControlName="impressao"
              inputId="pedidoImpressao58"></p-radioButton>
            <label for="pedidoImpressao58" class="ml-2 font-normal">
              {{ 'pedidos.imprimir_pedido.formatos.bobina_58' | translate }}
            </label>
          </div>
          <div class="flex items-center">
            <p-radioButton name="impressao" value="BOBINA_80" formControlName="impressao"
              inputId="pedidoImpressao80"></p-radioButton>
            <label for="pedidoImpressao80" class="ml-2 font-normal">
              {{ 'pedidos.imprimir_pedido.formatos.bobina_80' | translate }}
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [disabled]="isImprimindo"
      (click)="cancelar()">
      {{ 'pedidos.imprimir_pedido.botao_cancelar' | translate }} (Esc)
    </button>
    <button pButton icon="pi pi-print"
      [loading]="isImprimindo"
      (click)="imprimir()">
      {{ 'pedidos.imprimir_pedido.botao_imprimir' | translate }} (Enter)
    </button>
    <button pButton icon="pi pi-download" severity="success"
      [loading]="isImprimindo"
      (click)="baixar()"
      pTooltip="Ctrl+Shift+D" tooltipPosition="bottom">
      {{ 'pedidos.imprimir_pedido.botao_baixar' | translate }} (Ctrl+Shift+D)
    </button>
  </ng-template>
</p-dialog>
